// ┌──────────────────────────────────────────────┐
// │ Protection Plan Modal (E20-1342)               │
// └──────────────────────────────────────────────┘
// Wires one rendered coverage modal (snippets/bfx-protection-plan-modal.liquid): theme.Modals
// for open/close, ✕, click-outside, Esc and the focus trap, plus the in-modal chart link.
// Shared by the PDP, where the snippet's own inline call wires it on load, and the cart offer
// (E20-1832), which fetches the modal on demand and wires it after inserting it.
//
// init() is idempotent per modal id and hands back the theme.Modals instance, so a caller that
// needs to open the modal itself — rather than through a js-modal-open-* trigger — can.

{
  const instances = new Map();

  // The "chart below" links have to be handled here. A bare in-page anchor is picked up by
  // bfx-anchor-scroll, which scrolls the WINDOW — so the page behind the modal moves and the
  // grid never comes into view. The modal scrolls in its own container, so scroll the target
  // within it instead.
  //
  // Matches ANY in-modal hash link, not just the {chart} token's own marker: an editor can write
  // their own <a href="#…"> instead, which the field explicitly allows, and that link needs the
  // same treatment or it scrolls the page behind.
  const bindChartLinks = (modal) => {
    modal.addEventListener('click', (event) => {
      const link = event.target.closest('[data-pp-chart-link], a[href^="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      // querySelector('') throws and querySelector('#') matches nothing useful.
      if (!href || href.length < 2 || href.charAt(0) !== '#') return;

      const target = modal.querySelector(href);
      if (!target) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      // Scrolling alone strands keyboard and screen-reader users at the link, so move focus to
      // the grid too. preventScroll keeps the smooth scroll above intact.
      target.focus({ preventScroll: true });
    });
  };

  const init = (modalId) => {
    if (instances.has(modalId)) return instances.get(modalId);

    const modal = document.getElementById(modalId);
    if (!modal) return null;

    // The id doubles as the trigger name, so the PDP's js-modal-open-BfxProtectionPlanModal
    // class is still the whole of its wiring.
    const instance = new window.theme.Modals(modalId, modalId);
    bindChartLinks(modal);
    instances.set(modalId, instance);
    return instance;
  };

  window.bfxProtectionPlanModal = { init };
}
